import { dateFnsFormats } from "rtr-constants";
import { addDays, format } from "date-fns";
import { parseISOWithoutTime } from "helpers/date-helpers";
import type { WorkingFilters } from "components/types/working-filters";
import type { MouseEvent } from "react";

type SelectedDatesProps = {
  dateSelection?: string | null;
  duration: Exclude<WorkingFilters["duration"], undefined>;
  setReferenceDateValue: (referenceDate: Date) => void;
};

export default function SelectedDates({ dateSelection, duration, setReferenceDateValue }: SelectedDatesProps) {
  const dateFormat = dateFnsFormats.MMM_D;

  const containerClassName = "flex items-center rounded-md border border-lighterGray bg-white h-12 px-4";

  if (!dateSelection) {
    return (
      <div className={`${containerClassName} py-2 text-darkGray`}>
        <p className="w-1/2 text-md"> Arrival Date </p>
        <p className="w-1/2 text-md"> Return Date </p>
      </div>
    );
  }

  const selectedDateAsDateInstance = parseISOWithoutTime(dateSelection);
  const rentalEndDate = addDays(selectedDateAsDateInstance, parseInt(duration) - 1);

  const scrollToSelectedDate = (date: Date, event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();

    setReferenceDateValue(date);
  };

  return (
    <button
      data-test-id="scroll-to-date-button"
      aria-label="Show selected dates"
      onClick={e => scrollToSelectedDate(selectedDateAsDateInstance, e)}>
      <span className={`${containerClassName} py-1`}>
        <span className="flex flex-col items-start w-1/2 text-sm">
          <p className="text-darkGray text-sm"> Arrives By </p>
          <p className="text-md"> {format(selectedDateAsDateInstance, dateFormat)} </p>
        </span>
        <span className="flex flex-col items-start w-1/2">
          <p className="text-darkGray text-sm"> Return By </p>
          <p className="text-md"> {format(rentalEndDate, dateFormat)} </p>
        </span>
      </span>
    </button>
  );
}
